import * as React from 'react'
import { css } from 'glamor'

interface ITableCellRendererProps {
  children?: React.ReactNode
  align?: 'left' | 'center' | 'right'
}

export default function TableCellRenderer({ children, align }: ITableCellRendererProps) {
  return (
    <td
      {...css(
        {
          padding: '8px',
          lineHeight: '1.42857143',
          verticalAlign: 'top',
          borderBottom: '1px solid #ddd',
        },
        { textAlign: align }
      )}
    >
      {children}
    </td>
  )
}
